(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-category-nav"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('category-nav')) {
    /**
     * Category navigation component. Handles expand/collapse of sub-category lists.
     * @extends HTMLElement
     */
    customElements.define('category-nav', class CategoryNav extends HTMLElement {
      /** @type {AbortController} */
      #abortController;

      /** Attaches delegated handlers for toggle click and Escape key. */
      connectedCallback() {
        this.#abortController = new AbortController();
        const { signal } = this.#abortController;
        this.addEventListener('click', this.#handleClick, { signal });
        this.addEventListener('keydown', this.#handleKeydown, { signal });
      }

      /** Removes all event listeners. */
      disconnectedCallback() {
        this.#abortController.abort();
      }

      /** @param {MouseEvent} event */
      #handleClick = (event) => {
        const toggle = event.target.closest('.collection-category-nav__toggle');
        if (!toggle) return;
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        const sublist = this.querySelector(`#${toggle.getAttribute('aria-controls')}`);
        if (sublist) sublist.hidden = !sublist.hidden;
      };

      /** @param {KeyboardEvent} event */
      #handleKeydown = (event) => {
        if (event.key !== 'Escape') return;
        const toggle = event.target.closest('.collection-category-nav__toggle');
        if (!toggle) return;
        if (toggle.getAttribute('aria-expanded') !== 'true') return;
        event.preventDefault();
        toggle.setAttribute('aria-expanded', 'false');
        const sublist = this.querySelector(`#${toggle.getAttribute('aria-controls')}`);
        if (sublist) sublist.hidden = true;
        toggle.focus();
      };
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["twc-launchpoint"] && !Shopify.designMode) return;
  try {
    document.body.addEventListener('initTheWishlist', () => {
    if (typeof theWishlist === 'undefined') {
      return;
    }

    let getCountItem;
    try {
      getCountItem = theWishlist.countItemWishlist();
    } catch {
      return;
    }

    document.querySelectorAll('.wishlist__launch-point').forEach((el) => {
      el.classList.toggle('wishlist__launch-point--has-items', !!getCountItem);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
